import { Button, Image, Ratio } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

const Thumbnail = ({children, aspectRatio="1x1", as="", className="", src="", roundedCircle=false, to, target, onClick, removable=false, ariaDescribeBy=""}) => {

    const location = useLocation();


    if(as === "link") return(
        <Link to={to} target={target} state={{back: location.pathname}} className={"position-relative "+className} aria-describedby={ariaDescribeBy}>
            <ThumbnailBody aspectRatio={aspectRatio} src={src} roundedCircle={roundedCircle}/>
            {removable && <div className="position-absolute top-0 end-0 w-25 h-25"><box-icon size="md" color='#AAA' name='x'></box-icon></div>}
            {children}
        </Link>
    );

    else if(as === "button") return(
        <Button variant="link" onClick={onClick} className={"position-relative p-0 "+className} aria-describedby={ariaDescribeBy}>
            <ThumbnailBody aspectRatio={aspectRatio} src={src} roundedCircle={roundedCircle}/>
            {removable && <div className="position-absolute top-0 end-0 w-25 h-25"><box-icon size="md" color='#AAA' name='x'></box-icon></div>}
            {children}
        </Button>
    );

    else return(
        <div className={"position-relative "+className} aria-describedby={ariaDescribeBy}>
            <ThumbnailBody aspectRatio={aspectRatio} src={src} roundedCircle={roundedCircle}/>
            {removable && <div className="position-absolute top-0 end-0 w-25 h-25"><box-icon size="md" color='#AAA' name='x'></box-icon></div>}
            {children}
        </div>
    );
}

const ThumbnailBody = ({aspectRatio, src, roundedCircle}) => {

    return(
        <Ratio aspectRatio={aspectRatio}>
            <Image className="rounded-3 object-fit-cover" src={src} roundedCircle={roundedCircle} />
        </Ratio>
    )
}

export default Thumbnail;